import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Tabs } from '../../ui/components';
import { useT } from '../../i18n';

const TABS = [
  { id: 'recipes', label: 'Recipes' },
  { id: 'menu', label: 'Menu engineering' },
  { id: 'categories', label: 'Categories' },
];

const ROUTES = {
  recipes: '/recipes',
  menu: '/menu-engineering',
  categories: '/recipes/categories',
};

/**
 * Sub-navigation shared by the Recipes, Menu-engineering and Categories pages so they live under
 * one sidebar entry. `active` is 'recipes', 'menu' or 'categories'.
 */
export default function MenuNavTabs({ active }) {
  const navigate = useNavigate();
  const t = useT();
  return (
    <div style={{ marginBottom: 'var(--space-4)' }}>
      <Tabs
        tabs={TABS.map((x) => ({ ...x, label: t(x.label) }))}
        value={active}
        onChange={(id) => navigate(ROUTES[id] || '/recipes')}
        ariaLabel={t('Recipes and menu engineering')}
      />
    </div>
  );
}
